import { AlertTriangle } from "lucide-react";

import { relativeTime } from "../lib/relativeTime";

export interface MediaFailedJobCardProps {
  name: string;
  /** 给用户看的失败原因(人话);空则只显示「没排成」。 */
  reason?: string | null;
  createdAt?: string | null;
  onClick: () => void;
}

/**
 * 近期失败卡(2026-09-20)—— 还没落成任务就挂了的作业(一键长图规划期失败)。
 *
 * <p>★和 {@link MediaInProgressCard} 刻意分成两个组件:那张卡的转圈和「已等待」是写死的,
 * 加个 `failed` 开关迟早有人漏传 —— 失败卡就不该有任何会转的东西。
 */
export function MediaFailedJobCard({ name, reason, createdAt, onClick }: MediaFailedJobCardProps) {
  const at = relativeTime(createdAt);
  return (
    <button
      type="button"
      onClick={onClick}
      className="group fx-enter fx-hover-lift fx-press flex flex-col gap-2 rounded-2xl border border-destructive/30 bg-card p-4 text-left transition-colors hover:bg-accent/30"
    >
      <div className="flex items-center justify-between gap-2">
        <h3 className="truncate text-sm font-semibold">{name}</h3>
        {at && <span className="shrink-0 text-xs text-muted-foreground">{at}</span>}
      </div>
      <div className="flex items-start gap-1.5 text-xs text-destructive">
        <AlertTriangle className="mt-0.5 h-3 w-3 shrink-0" />
        <span className="line-clamp-3">{reason || "没排成,费用不扣"}</span>
      </div>
    </button>
  );
}
